const windowLocationPathname = window.location.pathname;
const langCode = windowLocationPathname.split('/')[1];
const countryCode = windowLocationPathname.split('/')[2];

// 季節出しわけの対象となるディレクトリ名
const SeasonalPages = ['itinerary15', 'itinerary16', 'itinerary17'];
// 春の対象となる国コード
const springCountries = [
  'au',
  'gb',
  'id',
  'my',
  'ph',
  'tw',
  'us',
  'th',
  'jp',
  'be',
  'ca',
  'ch',
  'eur',
  'in',
  'it',
  'kh',
  'vn',
  'at',
  'de',
  'fr',
];
// 冬の対象となる国コード
const fallCountries = ['hk', 'sg', 'es', 'mm', 'cn', 'kr'];

// 関西私鉄 特集TOPの展開ターゲット言語
const kansaiByRailTargetPaths = ['en/us', 'en/gb', 'en/au', 'fr/fr', 'zh/cn', 'zh/hk'];

export default class Season {
  /**
   * 関西私鉄 特集TOPの展開ターゲット言語となるディレクトリ名か判定します。
   * @example
   * import Season from '../lib/Season';
   * Season.isKansaiByRailTargetPath(); => true
   */
  static isKansaiByRailTargetPath() {
    const hasTargetPath = kansaiByRailTargetPaths.some(path => {
      return `${langCode}/${countryCode}`.includes(path);
    });
    const isSeasonalPage = this.isSeasonalPage();
    const isTargetPath = !!(hasTargetPath && isSeasonalPage);
    return isTargetPath;
  }

  /**
   * 季節出しわけの対象となるディレクトリ名か判定します。
   * @example
   * import Season from '../lib/Season';
   * Season.isSeasonalPage(); => true
   */
  static isSeasonalPage() {
    const hasSeasonalPage = SeasonalPages.some(page => {
      return windowLocationPathname.includes(page);
    });
    return hasSeasonalPage;
  }

  /**
   * 春の対象となる国コードか判定します。
   * @example
   * import Season from '../lib/Season';
   * Season.isSpring(); => true
   */
  static isSpring() {
    return springCountries.includes(countryCode);
  }

  /**
   * 冬の対象となる国コードか判定します。
   * @example
   * import Season from '../lib/Season';
   * Season.isFall(); => true
   */
  static isFall() {
    return fallCountries.includes(countryCode);
  }

  /**
   * 対象となる季節を返します。
   * @example
   * import Season from '../lib/Season';
   * Season.is(); => 'spring'
   */
  static is() {
    const isSpring = this.isSpring();
    const isFall = this.isFall();
    if (isSpring) {
      return 'spring';
    }
    if (isFall) {
      return 'fall';
    }
    return false;
  }
}
